import { GlobeLiveIcon } from "../../Icons";

export default function ChatHeader() {
  return (
    <div className="p-4 border-b flex items-center gap-2 font-semibold">
      <GlobeLiveIcon className="size-5" />
      Procurement AI
    </div>
  );
}
